import React from 'react'
import CardFeedDetails from 'src/app/CardFeedDetails/CardFeedDetails'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { cardFeedDetailsRouteProps } from 'src/navigation/routeProps'

const CardFeedDetailsAppRoute: AppRoute = {
  id: AppLocation.OrganizationSettingsCardFeedDetails,
  routeProps: cardFeedDetailsRouteProps,
  component: <CardFeedDetails />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default CardFeedDetailsAppRoute
